import React, { createContext, useState, useContext } from "react";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [backendFilterValues, setBackendFilterValues] = useState({});
  const [filterValues, setFilterValues] = useState({});
  const [appliedFilterValues, setAppliedFilterValues] = useState(JSON.parse(sessionStorage.getItem("appliedFilterValues")) || {});
  const [filterCount, setFilterCount] = useState(sessionStorage.getItem("filterChangeCount") || 0);

  const [isFilter, setFilter] = useState(false);
  const [isSetFilter, setIsSetFilter] = useState(false);
  const [isCollectionFilter, setIsCollectionFilter] = useState(false);
  const [isCatalogFilter, setIsCatalogFilter] = useState(false);
  const [createdByOptions, setCreatedByOptions] = useState([]);
  return (
    <FilterContext.Provider
      value={{
        filterValues,
        setFilterValues,
        isFilter,
        setFilter,
        backendFilterValues,
        setBackendFilterValues,
        isSetFilter,
        setIsSetFilter,
        filterCount,
        setFilterCount,
        isCollectionFilter,
        setIsCollectionFilter,
        appliedFilterValues,
        setAppliedFilterValues,
        isCatalogFilter,
        setIsCatalogFilter,
        createdByOptions,
        setCreatedByOptions,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => useContext(FilterContext);
